import React, { useCallback, useRef } from 'react';

import { join, map, split } from 'lodash';

import styles from './OtpInput.module.scss';

// interface Props {
//   onSubmit?: (otp: string) => void;
//   otp: string;
//   setOtp: React.Dispatch<React.SetStateAction<string>>;
// }

const OtpInput = (prop) => {
  const { onSubmit, setOtp, otp } = prop;
  const inputRefs = useRef([]);

  const focusNextInput = (index) => {
    if (index < 5) {
      const nextInput = inputRefs.current[index + 1];
      if (nextInput) {
        nextInput.focus();
      }
    }
  };

  const focusPrevInput = (index) => {
    if (index > 0) {
      const prevInput = inputRefs.current[index - 1];
      if (prevInput) {
        prevInput.focus();
      }
    }
  };

  const handleChange = useCallback(
    (index) => (e) => {
      const value = e.target.value;
      if (value) {
        focusNextInput(index);
      }

      setOtp((prevOtp) => {
        const otpArr = split(prevOtp, '');
        otpArr[index] = value;

        if (index === 5) {
          onSubmit && onSubmit(join(otpArr, ''));
        }

        return join(otpArr, '');
      });
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [otp]
  );

  const handleKeyUp = useCallback(
    (index) => (e) => {
      if (e.key === 'Backspace' && e.target.value === '') {
        focusPrevInput(index);
      }
    },
    []
  );

  return (
    <div className={styles.OtpInput}>
      {map(Array(6), (data, index) => (
        <input
          key={index}
          type='text'
          maxLength={1}
          className={styles.otpInput}
          name={`otp${index}`}
          onChange={handleChange(index)}
          onKeyUp={handleKeyUp(index)}
          // onFocus={(e) => e.target.select()}
          autoFocus={index === 0}
          ref={(el) => (inputRefs.current[index] = el)}
        />
      ))}
    </div>
  );
};

export default OtpInput;
